import video from '@/api/video.js'
import vtps from '@/api/vtps.js'
import videos from '@/api/videos.js'
export default {
    video,
    videos,
    vtps
}
